S.buttonPlay =
    {
        elements: {},

        init() {
            const video = this.$module.parent().find('.js-video').get(0);

            this.$module.click(() => {

                if (video.src)
                {
                    video.src = video.src.replace('&controls=0', '&controls=1&mute=1&autoplay=1');
                    S.mediastage.hideHeader();

                }
                else
                {
                    video.play();
                    S.mediastage.hideHeader();
                }
                this.$module.hide();
                this.$module.parent().find('img').hide();
            });
        },

    };
